import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/pages/dashboard/components/DashboardLayout';
import TopicForm from '@/pages/dashboard/forum/components/TopicForm';
import { useAuth } from '@/context/AuthContext';

function ForumNew() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">
          Nouvelle discussion
        </h1>
        <p className="text-sm text-foreground-400 mt-1">
          Posez une question ou partagez votre expérience avec la communauté.
        </p>
      </div>

      <div className="max-w-3xl">
        <TopicForm ownerId={user.id} onSaved={() => navigate('/dashboard/forum')} />
      </div>
    </DashboardLayout>
  );
}

export default ForumNew;